module.exports = __webpack_public_path__ + "img/Folded_Paper_Netflix_lijst.bc8a0417.jpg";